"use strict";
/* global $ */
exports.__esModule = true;
exports.FieldBlockDefinition = exports.FieldBlock = void 0;
var text_1 = require("../../../utils/text");
var FieldBlock = /** @class */ (function () {
    function FieldBlock(blockDef, placeholder, prefix, initialState, initialError) {
        this.blockDef = blockDef;
        this.type = blockDef.name;
        var dom = $("\n      <div class=\"" + text_1.escapeHtml(this.blockDef.meta.classname) + "\">\n        <div class=\"field-content\">\n          <div class=\"input\">\n            <div data-streamfield-widget></div>\n            <span></span>\n          </div>\n        </div>\n      </div>\n    ");
        $(placeholder).replaceWith(dom);
        var widgetElement = dom.find('[data-streamfield-widget]').get(0);
        this.element = dom[0];
        try {
            this.widget = this.blockDef.widget.render(widgetElement, prefix, prefix, initialState);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            this.setError([
                { messages: ['This widget failed to render, please check the console for details'] }
            ]);
            return;
        }
        this.idForLabel = this.widget.idForLabel;
        if (this.blockDef.meta.helpText) {
            var helpElement = document.createElement('p');
            helpElement.classList.add('help');
            helpElement.innerHTML = this.blockDef.meta.helpText; // unescaped, as per Django conventions
            this.element.querySelector('.field-content').appendChild(helpElement);
        }
        if (window.comments && this.blockDef.meta.showAddCommentButton) {
            var fieldCommentControlElement = document.createElement('div');
            fieldCommentControlElement.classList.add('field-comment-control');
            this.element.appendChild(fieldCommentControlElement);
            var addCommentButtonElement = document.createElement('button');
            addCommentButtonElement.type = 'button';
            addCommentButtonElement.setAttribute('aria-label', blockDef.meta.strings.ADD_COMMENT);
            addCommentButtonElement.setAttribute('data-comment-add', '');
            addCommentButtonElement.classList.add('button');
            addCommentButtonElement.classList.add('button-secondary');
            addCommentButtonElement.classList.add('button-small');
            addCommentButtonElement.classList.add('u-hidden');
            addCommentButtonElement.innerHTML = ('<svg class="icon icon-comment-add initial icon-default" aria-hidden="true" focusable="false">'
                + '<use href="#icon-comment-add"></use></svg>'
                + '<svg class="icon icon-comment-add initial icon-reversed" aria-hidden="true" focusable="false">'
                + '<use href="#icon-comment-add-reversed"></use></svg>');
            fieldCommentControlElement.appendChild(addCommentButtonElement);
            window.comments.initAddCommentButton(addCommentButtonElement);
        }
        if (initialError) {
            this.setError(initialError);
        }
    }
    FieldBlock.prototype.setState = function (state) {
        if (this.widget) {
            this.widget.setState(state);
        }
    };
    FieldBlock.prototype.setError = function (errorList) {
        this.element.querySelectorAll(':scope > .field-content > .error-message').forEach(function (element) { return element.remove(); });
        if (errorList) {
            this.element.classList.add('error');
            var errorElement = document.createElement('p');
            errorElement.classList.add('error-message');
            errorElement.innerHTML = errorList.map(function (error) { return "<span>" + text_1.escapeHtml(error.messages[0]) + "</span>"; }).join('');
            this.element.querySelector('.field-content').appendChild(errorElement);
        }
        else {
            this.element.classList.remove('error');
        }
    };
    FieldBlock.prototype.getState = function () {
        return this.widget.getState();
    };
    FieldBlock.prototype.getValue = function () {
        return this.widget.getValue();
    };
    FieldBlock.prototype.getTextLabel = function (opts) {
        if (this.widget.getTextLabel) {
            return this.widget.getTextLabel(opts);
        }
        return null;
    };
    FieldBlock.prototype.focus = function (opts) {
        if (this.widget) {
            this.widget.focus(opts);
        }
    };
    return FieldBlock;
}());
exports.FieldBlock = FieldBlock;
var FieldBlockDefinition = /** @class */ (function () {
    function FieldBlockDefinition(name, widget, meta) {
        this.name = name;
        this.widget = widget;
        this.meta = meta;
    }
    FieldBlockDefinition.prototype.render = function (placeholder, prefix, initialState, initialError) {
        return new FieldBlock(this, placeholder, prefix, initialState, initialError);
    };
    return FieldBlockDefinition;
}());
exports.FieldBlockDefinition = FieldBlockDefinition;
